// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
// @ts-nocheck
                        
import type * as SchemaTypes from '../index';

export const MoneyFragmentDoc = `
    fragment money on Money {
  __typename
  amount
  currency
}
    `;